import { set } from 'lodash';
import React, { useState, useEffect } from 'react';

const AjustarMetasDeActividad = (p) => {
    const [data, setdata] = useState({ ...p.data, distribucion: 16.7 });
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];

    const changeValue = (event) => {
        let { name, value } = event.target;
        let dt = { ...data };
        dt[name] = +value;
        setdata(dt);
    }

    const changedistribucion = (event) => {
        let { value } = event.target;
        let dt = { ...data };
        dt.distribucion = +value;
        if (dt.distribucion > 100) dt.distribucion = 100;
        if (dt.distribucion <= 0) dt.distribucion = 16.7;
        ajustar_distribucion(dt);
    }

    const changeMetaSemana = (event) => {
        let { value } = event.target;
        let dt = { ...data };
        dt[dias[0] + '_plan'] = +value;
        for (let i = 1; i < 6; i++) dt[dias[i] + '_plan'] = 0;
        ajustar_distribucion(dt);
    }

    const ajustar_distribucion = (dt) => {
        let total = 0;
        for (let i = 0; i < 6; i++) total += dt[dias[i] + '_plan'];
        let portion = Math.ceil(total / 100 * dt.distribucion);

        for (let i = 0; i < 6; i++) {
            if (total === 0) dt[dias[i] + '_plan'] = 0;
            else if (total < portion) {
                dt[dias[i] + '_plan'] = total;
                total = 0;
            } else {
                dt[dias[i] + '_plan'] = portion;
                total -= portion;
            }
        }
        if (total > 0) dt[dias[0] + '_plan'] += total;
        setdata(dt);
    }

    const total_registraado = (dt = { ...data }) => {
        return dt.lunes_plan + dt.martes_plan + dt.miercoles_plan + dt.jueves_plan + dt.viernes_plan + dt.sabado_plan;
    }

    async function actualizar_metas() {
        if (!p.editar) return;
        let dataSend = { id: data.id };
        for (let i = 0; i < 6; i++) {
            let field = dias[i] + '_plan';
            dataSend[field] = data[field];
        }
        if (!await p.editar(dataSend)) return;
        if (p.cerrarPadre) p.cerrarPadre();
    }

    return (
        <div className='vw-100 vh-100 m-0 p-2 fixed blur-s bg-white4 overflow' style={{ top: 0, left: 0, zIndex: 5 }}>
            <div className='col-auto me-3' style={{ marginTop: "60px", position: "absolute", right: 0, top: 0, zIndex: 2 }}>
                <button className='btn btn-danger border border-dark scale-continue-05 round-xxl shadow' onClick={p.close} >Cerrar sin guardar</button>
            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-700 shadow p-2 round-xxl bg-white4 blur-m' style={{ marginTop: "60px" }}>
                    <div className='w-100 h3 m-0 p-0'>Edición de actividad</div>
                    <div className='w-100 text-m m-0 p-0 text-300'>Ajuste las metas semanales definidas para esta actividad</div>
                </div>
                <div className={'bw-1400 p-2 round-s mr-0 ml-0 mt-2 mb-4 shadow bg-white '}>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='bw-400 text-bold text-l contenedor border-bottom mt-1'>
                            {data.labor}
                            <span className='text-center text-400 text-s ms-2'>{data.area}</span>
                        </div>
                        <div className='bw-250 text-s contenedor border-bottom mt-1 text-bold text-red3'>{data.bloque}</div>
                        <div className='bw-300 text-s contenedor border-bottom mt-1'>{data.unidad_hora} {data.unidad} X HORA</div>

                        <div className='bw-250 contenedor border-bottom mt-1'>
                            <div className='text-center text-bold text-xs text-red3'>
                                Rancho<span className='text-bold m-0 me-3 ms-1 text-xs text-dark'>{data.rancho ?? 'N/A'}</span>
                                Valvula:<span className='text-bold m-0 ms-1 me-0 text-s text-400 text-dark'>{data.valvula ?? "N/A"}</span>
                            </div>
                        </div>
                        <div className='bw-400 contenedor border-bottom border-bottom mt-1'>
                            <div className='text-center text-bold text-xs text-red3'>
                                Semana siembra<span className='m-0 me-3 ms-1 text-s text-400 text-dark'>{data.semana_siembra}</span>
                                Semana trasplante:<span className='m-0 ms-1 me-3 text-s text-400 text-dark'>{data.semana_trasplante}</span>
                                Semana cosecha:<span className='m-0 ms-1 me-0 text-s text-400 text-dark'>{data.semana_cosecha}</span>
                            </div>
                        </div>
                        <div className='w-100 m-0 p-0 mt-2'></div>

                        <div className='bw-150 mt-1' >
                            <div className='w-100 text-start text-bold text-s'>Meta semanal</div>
                            <input type='number' min={0} step={0.1}
                                className='form-control form-control-sm w-100 shadow border-warning border-2'
                                name={'meta_semana'}
                                defaultValue={total_registraado()}
                                onChange={changeMetaSemana} />
                        </div>

                        <div className='bw-100 mt-1' >
                            <div className='w-100 text-start text-bold text-xs'>Distribución</div>
                            <input type='number' min={0} max={100} step={0.1}
                                className='form-control form-control-sm w-100 shadow border border-warning border-2'
                                name={'distribucion'}
                                value={data.distribucion}
                                onChange={changedistribucion} />
                        </div>

                        {
                            dias.map((d) => {
                                return (
                                    <div className='bw-100 mt-1' key={data.id + " dia" + d}>
                                        <div className='w-100 text-start text-bold text-xs'>{d.toUpperCase()}</div>
                                        <input type='number' min={0}

                                            disabled={data.registrada === 1}
                                            className='form-control form-control-sm w-100 shadow  border-grey3' name={d + "_plan"} value={data[(d + "_plan")]} onChange={changeValue} />
                                    </div>
                                )
                            })
                        }

                        <div className='w-100 m-0 p-0'></div>
                        <button className={'btn btn-sm border round-xxl bw-300 text-bold mt-3 mb-4 scale-025 shadow btn-warning'}
                            disabled={data.registrada === 1 || total_registraado(data) === 0}
                            onClick={actualizar_metas}>{total_registraado(data) === 0 ? 'Agregue cantidades al menos a un día' : 'Guardar'}</button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AjustarMetasDeActividad;